import { Field } from 'formik';
import { EmailInput } from 'pg-ui-library';
import styled from 'styled-components';

// Containers

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const MenuContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 30%;
  min-width: 500px;
  border-radius: 0 30px 30px 0;
  background-color: white;
  flex-direction: column;
  position: absolute;
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: flex-end;
`;

export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: 16px;
  @media (min-height: 700px) {
    justify-content: center;
  }
`;

export const TextContainer = styled.div`
  width: 80%;
  display: block;
`;

export const FooterContainer = styled.div`
  width: 100%;
  display: flex;
  margin: 1.5rem 0;
  height: max-content;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
`;

export const LinkContainer = styled.div`
  min-width: max-content;
  display: flex;
  justify-content: space-between;
  gap: 18px;
`;

// Images

export const Logo = styled.img`
  width: 60%;
  height: auto;
  margin-bottom: 25px;
`;

export const BackgroundImage = styled.img`
  height: 100%;
  min-width: calc(100vw - 450px);
  object-fit: cover;
`;

// Texts

export const Text = styled.p`
  font-size: 13px;
  margin: 4px;
  padding: 0;
`;

export const GrayText = styled(Text)`
  color: #3b3b3b;
  font-weight: bold;
`;

export const RedText = styled(Text)`
  color: #ff0000;
`;

export const GreenText = styled(Text)`
  color: #00ff00;
`;

export const FormTitle = styled.h3`
  text-transform: uppercase;
  margin: 0 0 16px 0;
  text-align: center;
`;

export const ErrorText = styled(Text)`
  font-size: 10px;
  color: red;
`;

export const FooterText = styled(Text)`
  font-size: 12px;
  font-weight: 400;
`;

export const SignUpInput = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 44px;
  width: 400px;
  margin-top: 22px;
  .pg-dropdown-label {
    display: none;
  }
`;

export const InputSelect = styled.select`
  width: 100%;
  height: 44px;
  font-weight: 600;
  padding: 0 1rem;
  border: 1px solid rgb(201, 203, 211);
  border-radius: 4px;
  background-color: #fff;
  appearance: none;
  cursor: pointer;
  color: ${({ value }) => (value ? '#000' : '#9399b2')};
  &:focus {
    outline: none;
    border-color: #5b7cff;
  }
`;

export const PersonalEmailInput = styled(EmailInput)`
  margin-top: 22px !important;
`;

export const InputIcon = styled.img`
  position: absolute;
  height: auto;
  width: 18px;
  left: 16px;
`;

export const UsernameInput = styled(Field)`
  max-width: 100%;
  height: 100%;
  width: 100%;
  padding: 0 80px 0 42px;
  font-weight: bold;
  border: 1px solid #c9cbd3;
  border-radius: 4px;
  &::placeholder {
    color: #9399b2;
    font-weight: 400;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 44px;
  font-weight: 600;
  padding: 0 1rem;
  border: 1px solid rgb(201, 203, 211);
  border-radius: 4px;
`;

export const Step1Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 22px;
  min-width: 300px;
`;

export const ActionWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
`;
